const getVariantPriceFromData = (variant: any, productPrice: number, filteredOptions: any) => {
  let basePrice = Number(productPrice) || 0;
  Object.keys(filteredOptions).forEach((optionId: string) => {
    const filteredVariant = filteredOptions[optionId];
    if (filteredVariant) {
      const variantPrice = filteredVariant.price || 0;
      basePrice += variantPrice;
    }
  });
  const variantPriceValue = Number(variant?.price_value || 0);
  return Math.ceil((basePrice * variantPriceValue) / 100);
};
const getVariantOldPriceFromData = (variant: any, productPrice: number, filteredOptions: any) => {
  let basePrice = Number(productPrice) || 0;
  Object.keys(filteredOptions).forEach((optionId: string) => {
    const filteredVariant = filteredOptions[optionId];
    if (filteredVariant) {
      const variantPrice = filteredVariant.price_old || 0;
      basePrice += variantPrice;
    }
  });
  const variantPriceValue = Number(variant?.price_old_value || 0);
  return Math.ceil((basePrice * variantPriceValue) / 100);
};

const getTotalPriceOptions = (options: any, productPrice: any, listOptions: any) => {
  let _seletedPriceValue = 0;
  listOptions.forEach((option: any, index: number) => {
    const optionId = String(option.id);
    const variant = options[optionId];
    if (!variant) return;

    let sumPrice = variant.price || 0;
    if ((variant?.priceRelationGroups || []).length > 0) {
      const _productOptions = index > 0 ? listOptions.slice(0, index) : [];
      const filteredOption = Object.keys(options).reduce((acc: any, key: string) => {
        if (
          _productOptions.some((opt: any) => String(opt?.id) === String(key)) &&
          (variant.priceRelationGroups || []).some((groupId: any) => String(groupId?.id || groupId) === String(key))
        ) {
          acc[key] = options[key];
        }
        return acc;
      }, {});
      sumPrice = getVariantPriceFromData(variant, productPrice, filteredOption);
    }
    _seletedPriceValue += sumPrice;
  });
  return _seletedPriceValue;
};
const getTotalOldPriceOptions = (options: any, productPrice: any, listOptions: any) => {
  let _seletedPriceValue = 0;
  listOptions.forEach((option: any, index: number) => {
    const optionId = String(option.id);
    const variant = options[optionId];
    if (!variant) return;

    let sumPrice = variant.price_old || 0;
    if ((variant?.priceRelationGroups || []).length > 0) {
      const _productOptions = index > 0 ? listOptions.slice(0, index) : [];
      const filteredOption = Object.keys(options).reduce((acc: any, key: string) => {
        if (
          _productOptions.some((opt: any) => String(opt?.id) === String(key)) &&
          (variant.priceRelationGroups || []).some((groupId: any) => String(groupId?.id || groupId) === String(key))
        ) {
          acc[key] = options[key];
        }
        return acc;
      }, {});
      sumPrice = getVariantOldPriceFromData(variant, productPrice, filteredOption);
    }
    _seletedPriceValue += sumPrice;
  });
  return _seletedPriceValue;
}

const getVariantPriceRelationGroups = (productPrice: number, variantPrice: number, options: any) => {
  const _variantPrice = Number(variantPrice) || 0;

  let _seletedPriceValue = Number(productPrice) || 0;
  Object.keys(options).forEach((optionId: any) => {
    const elOption: any = document.querySelector(`[data-select-option-id="${optionId}"]`);
    if (!!elOption) {
      const elPrice = elOption.querySelector(`[data-price]`);
      const priceValue: string = elPrice?.getAttribute('data-price');
      const parsedPrice = Number.parseFloat(priceValue) || 0;
      _seletedPriceValue = _seletedPriceValue + parsedPrice;
    }
  });
  const result = (_seletedPriceValue * _variantPrice) / 100;
  return Math.ceil(result);
}
const getVariantOldPriceRelationGroups = (productPrice: number, variantPrice: number, options: any) => {
  const _variantPrice = Number(variantPrice) || 0;

  let _seletedPriceValue = Number(productPrice) || 0;
  Object.keys(options).forEach((optionId: any) => {
    const elOption: any = document.querySelector(`[data-select-option-id="${optionId}"]`);
    if (!!elOption) {
      const elPrice = elOption.querySelector(`[data-old-price]`);
      const priceValue: string = elPrice?.getAttribute('data-old-price') || '0';
      const parsedPrice = Number.parseFloat(priceValue) || 0;
      _seletedPriceValue = _seletedPriceValue + parsedPrice;
    }
  });

  const result = (_seletedPriceValue * _variantPrice) / 100;
  return Math.ceil(result);
}

export {
  getTotalPriceOptions,
  getTotalOldPriceOptions,
  getVariantPriceRelationGroups,
  getVariantOldPriceRelationGroups
}
